export const ITEMS_PER_PAGE = 100;

const ContentCategorySelectionAutomatedTestIds = {
  INPUT_CONTENT_CATEGORY: 'input-content-category',
};

export const defaultCategory = () => ({
  name: '',
  linkName: '',
  mediumId: null,
  brandsMenuId: null,
  color: '#FFFFFF',
  options: {
    isSportsEnabled: false,
    isAdvertisementVisibilityEnabled: false,
    isContentCreationDisabled: false,
  },
  order: 0,
  isApproved: true,
});

export const CategoryTableHeader = [
  {
    value: 'order',
    sortable: false,
    align: 'start',
    langPath: 'content',
    langKey: 'ORDER',
  },
  {
    value: 'name',
    sortable: false,
    align: 'start',
    langPath: 'content',
    langKey: 'CATEGORY_NAME',
  },
  {
    value: 'contentTypes',
    sortable: false,
    align: 'start',
    langPath: 'content',
    langKey: 'CONTENT_TYPE',
  },
  {
    value: 'other',
    sortable: false,
    align: 'end',
    langPath: 'app',
    langKey: 'OTHER',
  },
];

export default ContentCategorySelectionAutomatedTestIds;
